import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useMe, useParticipant, useSessionProposals } from '@app/api';
import { OnboardingLayout } from './OnboardingLayout';
import { useTranslation } from 'react-i18next';
import { ApplyToStudies } from '../Home/components/ApplyToStudies';
import { Navigate } from 'react-router-dom';
import { CenteredLoader } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    marginTop: theme.marginBase * 6,
  },
  studies: {
    marginTop: theme.marginBase * 4,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3,
  },
  cardContainer: {
    width: '100%',
  },
}));
export const StudyProposals = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: sessions, error, isLoading } = useSessionProposals();

  const { data: me } = useMe();
  const { data: participant } = useParticipant(
    me?.linkedParticipants?.length ? me.linkedParticipants[0] : undefined,
  );

  if (error || (sessions && sessions.length === 0)) {
    return <Navigate to="/" />;
  }

  return (
    <OnboardingLayout isLoading={!participant}>
      <h1 className={classes.title}>
        {t('onboarding.studies.title', { firstName: participant?.firstName })}
      </h1>

      <div className={classes.studies}>
        {isLoading && <CenteredLoader />}
        {sessions?.map((session) => (
          <ApplyToStudies
            key={session.id}
            session={session}
            className={classes.cardContainer}
          />
        ))}
      </div>
    </OnboardingLayout>
  );
};
